import { PropTypes } from 'prop-types';
import React from 'react';
import { InfoContainer, Fonts } from '@custom-components';
import ToDoItem from './ToDoItem';
import { Loading } from '../../../components/Loading/Loading';

function ToDoList(props) {
  const { actions, loading } = props;

  return (
    <InfoContainer noPadding leftSubBarContents={[{ type: 'label', props: { label: 'To-Do' } }]}>
      <div style={{ maxHeight: 'calc(100vh - 335px)', overflowY: 'auto' }}>
        {actions.map(action => (
          <ToDoItem {...action} key={action.id} />
        ))}
        {loading && <Loading />}
        {!loading && !actions?.length && <Fonts.StyledText>No Actions</Fonts.StyledText>}
      </div>
    </InfoContainer>
  );
}

ToDoList.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      itemTitle: PropTypes.string.isRequired,
      itemSubTitle: PropTypes.string.isRequired,
      action: PropTypes.func
    })
  ).isRequired,
  loading: PropTypes.bool
};
ToDoList.defaultProps = {
  loading: false
};

export default ToDoList;
